export default defineNuxtRouteMiddleware((_to, _from) => {
  // Check if country is already stored
  const countryCookie = useCookie('country')
  if (countryCookie.value) return

  // Only run on server-side where headers are available
  if (import.meta.server) {
    try {
      // Get country from Vercel's geolocation header
      const headers = useRequestHeaders()
      const country = headers['x-vercel-ip-country'] || 'ZZ'

      // Store the country code in a cookie
      countryCookie.value = country
    } catch (error) {
      console.error('Failed to detect country:', error)
      countryCookie.value = 'ZZ'
    }
  }
})
